import React from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import axios from "axios";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import DuoIcon from "@mui/icons-material/Duo";
import RelatedTeacher from "./RelatedTeacher";
import { stateCity } from "../../common/cityData";
import LabelImportantIcon from "@mui/icons-material/LabelImportant";

const Teacherlist = ({ id }) => {
  const { examId } = useParams();
  const headerRef = useRef(null);
  const [teachers, setTeachers] = useState([]);

  const [examData, setExamData] = useState([]); // Store filtered exam data
  const [courseData, setCourseData] = useState([]);
  const [price, setPrice] = useState(0); // State to track the selected price

  //tabs
  const [activeTab, setActiveTab] = useState("one");

  const [formData, setFormData] = useState({
    examination: "",
    subject: "",
    state: "",
    city: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let critariaArr = [];

    if (formData.examination) {
      // Exam selected → include everything
      critariaArr = [
        formData.examination,
        formData.subject,
        formData.state,
        formData.city,
      ];
    } else {
      // Exam NOT selected → only state + city
      critariaArr = [formData.state, formData.city];
    }

    const critaria = critariaArr.filter(Boolean).join(" ");

    try {
      const response = await axios.get(
        `https://topfaculty.co.in/api/teacher-list2.php?critaria=${encodeURIComponent(
          critaria,
        )}`,
      );

      if (response.data.length === 0) {
        console.log("No matching records found.");
      } else {
        setTeachers(response.data);
        console.log("Fetched Teachers:", response.data);
      }
    } catch (error) {
      console.error("Error fetching teachers:", error);
    }
  };

  // USING TOP SCROLL
  useEffect(() => {
    if (headerRef.current) {
      headerRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [examId]);
  // END OF TOP SCROLL

  useEffect(() => {
    const fetchTeachers = async () => {
      try {
        const response = await axios.get(
          `https://topfaculty.co.in/api/teacher-list2.php${
            examId ? `?critaria=${examId}` : ""
          }`,
        );

        const response2 = await axios.get(
          "https://topfaculty.co.in/api/teacher-list2.php",
        );
        console.log(response.data);
        setTeachers(response.data);

        // Extract unique exams and courses
        const seenExams = new Set();
        const seenCourses = new Set();
        const exams = [];
        const courses = [];

        response2.data.forEach((teacher) => {
          const exam = teacher.TeacherExamination.toLowerCase();
          const course = teacher.TeacherSubject.toLowerCase();

          if (!seenExams.has(exam)) {
            seenExams.add(exam);
            exams.push({
              id: teacher.TeacherId,
              exam: teacher.TeacherExamination,
            });
          }

          if (!seenCourses.has(course)) {
            seenCourses.add(course);
            courses.push({
              id: teacher.TeacherId,
              course: teacher.TeacherSubject,
            });
          }
        });

        setExamData(exams);
        setCourseData(courses);
      } catch (error) {
        console.log("Error Fetching Data", error);
      }
    };

    fetchTeachers();
  }, [examId]);

  // Place this outside your map loop (only once)
  const handleShare = (teacherId, teacherName) => {
    const teacherNameEncoded = encodeURIComponent(teacherName);
    const shareUrl = `https://topfaculty.co.in/#/teacher/${teacherId}/${teacherNameEncoded}`;

    if (navigator.share) {
      navigator
        .share({
          title: `Check out ${teacherName} on TopFaculty`,
          url: shareUrl,
        })
        .then(() => console.log("Profile shared!"))
        .catch((error) => console.error("Share failed:", error));
    } else {
      navigator.clipboard.writeText(shareUrl);
      alert("Link copied to clipboard!");
    }
  };

  // state city

  useEffect(() => {
    // jQuery-style logic
    const stateDropdown = document.getElementById("inputState");
    const cityDropdown = document.getElementById("inputDistrict");

    stateDropdown.addEventListener("change", function () {
      const selectedState = this.value;
      const cities = stateCity[selectedState] || [];

      // Clear previous cities
      cityDropdown.innerHTML = '<option value="">-- select one --</option>';

      // Append new city options
      cities.forEach((city) => {
        const option = document.createElement("option");
        option.value = city;
        option.textContent = city;
        cityDropdown.appendChild(option);
      });
    });
  }, []);

  const tabStyle = {
    border: "none",
    borderRadius: "10px",
    padding: "10px 22px",
    fontWeight: "800",
    background: "rgb(205 222 255)",
    color: "black",
    marginRight: "8px",
    transition: "all 0.3s ease",
  };

  const activeTabStyle = {
    // background: "linear-gradient(135deg, #ff512f, #f09819)",
    background: "linear-gradient(135deg, rgb(205 34 0), rgb(255 83 83))",
    color: "#fff",
    boxShadow: "0 6px 15px rgba(255,81,47,0.4)",
  };

  const contentStyle = {
    background: "#ffffff",
    borderRadius: "14px",
    padding: "25px",
    marginTop: "15px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
  };

  return (
    <>
      <div className="rs-courses-details " ref={headerRef}>
        <img
          src="assetsfront/images/ourteacher.jpg"
          alt="student registration"
          style={{
            marginTop: "0%",
            width: "100%",
            // height: "200px",
            objectFit: "cover",
          }}
        />
        <div className="container">
          <h1
            className="title text-center  mt-4 "
            style={{ fontWeight: "600" }}
          >
            📘 All <strong style={{ color: "#f7b205" }}> Faculty</strong>
          </h1>

          {/* search */}
          <form
            onSubmit={handleSubmit}
            style={{
              boxShadow: "rgba(17, 17, 26, 0.1) 0px 0px 16px",
              // position: "sticky",
              top: "10%",
              right: "0",
              zIndex: "9999",
              background: "white",
            }}
          >
            <div className="row p-4">
              <div className="col-lg-3 col-4 form-group position-relative  ">
                <label style={{ color: "#ff3115" }}>Examination</label>
                <select
                  className="form-control"
                  name="examination"
                  value={formData.examination}
                  onChange={handleChange}
                >
                  <option value="">Select Exam --</option>
                  {examData.map((exam) => (
                    <option key={exam.id} value={exam.exam}>
                      {exam.exam}
                    </option>
                  ))}
                </select>
              </div>
              {/* <div className="col-lg-3 col-4 form-group position-relative ">
                <label style={{ color: "#ff3115" }}>Subject</label>
                <select
                  class="form-control"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                >
                  <option value="">Select Subject --</option>
                  {courseData.map((course) => (
                    <option key={course.id} value={course.course}>
                      {course.course}
                    </option>
                  ))}
                </select>
              </div> */}
              <div className="col-lg-3 col-4 form-group position-relative">
                <label style={{ color: "#ff3115" }}>State</label>
                <select
                  class="form-control"
                  id="inputState"
                  name="state"
                  value={formData.state}
                  onChange={handleChange}
                >
                  <option value="SelectState">Select State</option>
                  <option value="Andra Pradesh">Andra Pradesh</option>
                  <option value="Arunachal Pradesh">Arunachal Pradesh</option>
                  <option value="Assam">Assam</option>
                  <option value="Bihar">Bihar</option>
                  <option value="Chhattisgarh">Chhattisgarh</option>
                  <option value="Goa">Goa</option>
                  <option value="Gujarat">Gujarat</option>
                  <option value="Haryana">Haryana</option>
                  <option value="Himachal Pradesh">Himachal Pradesh</option>
                  <option value="Jammu and Kashmir">Jammu and Kashmir</option>
                  <option value="Jharkhand">Jharkhand</option>
                  <option value="Karnataka">Karnataka</option>
                  <option value="Kerala">Kerala</option>
                  <option value="Madya Pradesh">Madya Pradesh</option>
                  <option value="Maharashtra">Maharashtra</option>
                  <option value="Manipur">Manipur</option>
                  <option value="Meghalaya">Meghalaya</option>
                  <option value="Mizoram">Mizoram</option>
                  <option value="Nagaland">Nagaland</option>
                  <option value="Odisha">Odisha</option>
                  <option value="Punjab">Punjab</option>
                  <option value="Rajasthan">Rajasthan</option>
                  <option value="Sikkim">Sikkim</option>
                  <option value="Tamil Nadu">Tamil Nadu</option>
                  <option value="Telangana">Telangana</option>
                  <option value="Tripura">Tripura</option>
                  <option value="Uttaranchal">Uttaranchal</option>
                  <option value="Uttar Pradesh">Uttar Pradesh</option>
                  <option value="West Bengal">West Bengal</option>
                  <option
                    disabled
                    style={{
                      backgroundColor: "#aaa",
                      color: "#fff",
                    }}
                  >
                    UNION Territories
                  </option>
                  <option value="Andaman and Nicobar Islands">
                    Andaman and Nicobar Islands
                  </option>
                  <option value="Chandigarh">Chandigarh</option>
                  <option value="Dadar and Nagar Haveli">
                    Dadar and Nagar Haveli
                  </option>
                  <option value="Daman and Diu">Daman and Diu</option>
                  <option value="Delhi">Delhi</option>
                  <option value="Lakshadeep">Lakshadeep</option>
                  <option value="Pondicherry">Pondicherry</option>
                </select>
              </div>
              <div className="col-lg-3 col-6 form-group position-relative ">
                <label style={{ color: "#ff3115" }}>City</label>

                <select
                  class="form-control"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  id="inputDistrict"
                >
                  <option value="">Select City -- </option>
                </select>
              </div>

              <div className="col-lg-2 col-6 form-group   ">
                <button
                  style={{ marginTop: "30px" }}
                  type="submit"
                  className="btn btn-primary btn-block shadow border-0 py-2 text-uppercase rounded"
                >
                  Search
                </button>
              </div>
            </div>
          </form>

          {/* close search */}

          <div className="row mt-2">
            <div className="col-lg-3 col-md-12" style={{ alignSelf: "auto" }}>
              <div className="sidebar-area">
                <div className="newsletter">
                  <h4>FILTERS</h4>
                  <hr style={{ border: "2px solid #ccc", margin: "12px 0" }} />

                  <form
                    onSubmit={handleSubmit}
                    style={
                      {
                        // boxShadow: "rgba(17, 17, 26, 0.1) 0px 0px 16px",
                        // borderRadius: "5px",
                        // background: "white",
                      }
                    }
                  >
                    <div className="row py-1 px-2">
                      <div className="col-lg-9 col-8 form-group position-relative">
                        <label style={{ color: "#ff3115" }}>Subject</label>
                        <select
                          style={{ height: "42px", background: "white" }}
                          className="form-control"
                          name="subject"
                          value={formData.subject}
                          onChange={handleChange}
                        >
                          <option value="">Select Subject --</option>
                          {courseData &&
                            courseData.map((course) => (
                              <option key={course.id} value={course.course}>
                                {course.course}
                              </option>
                            ))}
                        </select>
                      </div>
                      <div className="col-lg-2 col-4 form-group   ">
                        <button
                          style={{ marginTop: "30px" }}
                          type="submit"
                          className="btn btn-primary btn-block shadow border-0 text-uppercase rounded"
                        >
                          <i class="fa fa-search" aria-hidden="true"></i>
                        </button>
                      </div>
                    </div>
                  </form>

                  <div className="box-newsletter">
                    <div class="tags-cloud clearfix">
                      <ul>
                        <p className="title">Examination</p>
                        <div className="my-scrollable p-2">
                          <ul>
                            {examData && examData.length > 0 ? (
                              examData.map((exam) => (
                                <li key={exam.id}>
                                  <Link
                                    style={{
                                      color:
                                        examId === exam.exam
                                          ? "white"
                                          : "black",
                                      textDecoration: "none",
                                      fontWeight:
                                        examId === exam.exam ? "bold" : "700",
                                      background:
                                        examId === exam.exam ? "#0d6efd" : "",
                                      padding:
                                        examId === exam.exam ? "4px" : "",
                                      borderRadius:
                                        examId === exam.exam ? "4px" : "3px",
                                    }}
                                    to={`/myteacherlist/${exam.exam}`}
                                  >
                                    {exam.exam}
                                    {/* <KeyboardDoubleArrowRightIcon /> */}
                                  </Link>
                                </li>
                              ))
                            ) : (
                              <li>
                                <span
                                  style={{
                                    fontWeight: "bold",
                                    color: "blue",
                                    fontSize: "25px",
                                  }}
                                >
                                  Please wait
                                  <span className="dot-loader">
                                    <span className="dot"></span>
                                    <span className="dot"></span>
                                    <span className="dot"></span>
                                    <span className="dot"></span>
                                    <span className="dot"></span>
                                    <span className="dot"></span>
                                    <span className="dot"></span>
                                    <span className="dot"></span>
                                    <span className="dot"></span>
                                  </span>
                                </span>
                              </li> // or <p>Loading...</p> if you're still fetching
                            )}
                          </ul>
                        </div>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-9 col-md-12 p-1">
              {/* Tabs */}
              <ul className="nav nav-tabs" style={{ borderBottom: "none" }}>
                <li className="nav-item">
                  <button
                    className="nav-link"
                    style={{
                      ...tabStyle,
                      ...(activeTab === "one" ? activeTabStyle : {}),
                    }}
                    onClick={() => setActiveTab("one")}
                  >
                    Our Top Faculty <LabelImportantIcon />
                  </button>
                </li>

                <li className="nav-item">
                  <button
                    className="nav-link"
                    style={{
                      ...tabStyle,
                      ...(activeTab === "two" ? activeTabStyle : {}),
                    }}
                    onClick={() => setActiveTab("two")}
                  >
                    Our Related Faculty <LabelImportantIcon />
                  </button>
                </li>

                <li className="nav-item">
                  <button
                    className="nav-link"
                    style={{
                      ...tabStyle,
                      ...(activeTab === "three" ? activeTabStyle : {}),
                    }}
                    onClick={() => setActiveTab("three")}
                  >
                    UPSC <LabelImportantIcon />
                  </button>
                </li>

                <li className="nav-item">
                  <button
                    className="nav-link"
                    style={{
                      ...tabStyle,
                      ...(activeTab === "four" ? activeTabStyle : {}),
                    }}
                    onClick={() => setActiveTab("four")}
                  >
                    Teaching <LabelImportantIcon />
                  </button>
                </li>
              </ul>

              {/* Tab Content */}
              <div className="tab-content" style={{ marginTop: "3%" }}>
                {activeTab === "one" && (
                  <div>
                    {teachers && teachers.length > 0 ? (
                      teachers
                        .filter((teacher) => {
                          if (!teacher.videoLink) return false;

                          try {
                            const videos = Array.isArray(teacher.videoLink)
                              ? teacher.videoLink
                              : JSON.parse(teacher.videoLink || "[]");

                            return videos.length > 0;
                          } catch {
                            return false;
                          }
                        })
                        .map((teacher, index) => (
                          <div className="course-content p-1">
                            <div className="course-instructor">
                              <div className="row">
                                <div className="col-md-3 mobile-mb-20">
                                  <h3 className="instructor-title">
                                    COURSE{" "}
                                    <span className="primary-color">
                                      INSTRUCTOR{" "}
                                    </span>
                                  </h3>
                                  <div className="instructor-inner">
                                    {/* Ribbon */}

                                    {teacher.TeacherStatus === "verify" ? (
                                      <div className="ribbon ribbon-top-left">
                                        <span>VERIFY</span>
                                      </div>
                                    ) : teacher.TeacherStatus ===
                                      "un_verify" ? (
                                      <div className="ribbon2">
                                        <span>Under-Verification</span>
                                      </div>
                                    ) : null}

                                    <div className="instructor-img">
                                      <img
                                        style={{ maxWidth: "65%" }}
                                        src={
                                          teacher.TeacherProfile
                                            ? teacher.TeacherProfile
                                            : "https://i.pinimg.com/736x/5f/40/6a/5f406ab25e8942cbe0da6485afd26b71.jpg"
                                        }
                                        alt={teacher.TeacherName}
                                      />
                                    </div>
                                  </div>

                                  <div className="instructor-body">
                                    <h4
                                      className="name"
                                      style={{
                                        marginBottom: "2px",
                                        color: "#007bff",
                                        fontWeight: "800",
                                      }}
                                    >
                                      {teacher.TeacherName}{" "}
                                    </h4>

                                    <span
                                      className="designation"
                                      style={{
                                        color: "black",
                                        fontWeight: "600",
                                      }}
                                      title={teacher.TeacherEmail}
                                    >
                                      {teacher.TeacherEmail.length > 17
                                        ? teacher.TeacherEmail.substring(
                                            0,
                                            17,
                                          ) + "..."
                                        : teacher.TeacherEmail}
                                    </span>
                                    <div
                                      className="social-icon mt-2"
                                      style={{ letterSpacing: "9px" }}
                                    >
                                      {/* <a href={`tel:${teacher.TeacherMobile}`}><img src="assetsfront/images/phon.png" style={{width: "32px",height: "34px"}}/></a> */}
                                      {/* <a className="adds" href={`mailto:${teacher.TeacherEmail}`}><img src="assetsfront/images/email.jpg" style={{width: "32px",height: "34px"}}/></a> */}
                                      <a
                                        className="adds"
                                        href={teacher.facebook}
                                      >
                                        <img
                                          src="assetsfront/images/facebook.png"
                                          style={{
                                            width: "32px",
                                            height: "34px",
                                          }}
                                        />
                                      </a>
                                      <a
                                        className="adds"
                                        href={teacher.youtube}
                                      >
                                        <img
                                          src="assetsfront/images/youtube.png"
                                          style={{
                                            width: "32px",
                                            height: "34px",
                                          }}
                                        />
                                      </a>
                                      <a
                                        className="adds"
                                        href={teacher.twitter}
                                      >
                                        <img
                                          src="assetsfront/images/tweet.webp"
                                          style={{
                                            width: "32px",
                                            height: "34px",
                                          }}
                                        />
                                      </a>
                                      <a className="adds" href={teacher.insta}>
                                        <img
                                          src="assetsfront/images/instagram.png"
                                          style={{
                                            width: "32px",
                                            height: "34px",
                                          }}
                                        />
                                      </a>
                                      <a
                                        className="adds"
                                        href={teacher.telegram}
                                      >
                                        <img
                                          src="assetsfront/images/telegram.png"
                                          style={{
                                            width: "32px",
                                            height: "34px",
                                          }}
                                        />
                                      </a>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-9">
                                  <h3 className="instructor-title">
                                    BASIC{" "}
                                    <span className="primary-color">
                                      INFORMATION
                                    </span>
                                  </h3>

                                  <div className="row info-list">
                                    <div className="col-md-7">
                                      <p style={{ fontWeight: "600" }}>
                                        Top Faculty is a powerful platform for
                                        educators to reach students across India
                                        and share their expertise.
                                      </p>

                                      <table
                                        class="table table-striped"
                                        style={{
                                          boxShadow:
                                            "rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px",
                                        }}
                                      >
                                        <tbody>
                                          <tr>
                                            <th scope="row">Online Classes</th>

                                            <td style={{ width: "100%" }}>
                                              Demo <br></br>
                                              {/* Video link block */}
                                              {(() => {
                                                const videoLinks =
                                                  Array.isArray(
                                                    teacher.videoLink,
                                                  )
                                                    ? teacher.videoLink
                                                    : JSON.parse(
                                                        teacher.videoLink ||
                                                          "[]",
                                                      );
                                                const firstThreeLinks =
                                                  videoLinks.slice(0, 6); // Limit to first 3
                                                return firstThreeLinks.length >
                                                  0 ? (
                                                  firstThreeLinks.map(
                                                    (onvideo, idx) => (
                                                      <span key={idx}>
                                                        <a
                                                          href={`${onvideo}`}
                                                          style={{
                                                            color: "black",
                                                          }}
                                                          target="_blank"
                                                          rel="noopener noreferrer"
                                                        >
                                                          <i
                                                            className="fa fa-video-camera"
                                                            style={{
                                                              fontSize: "16px",
                                                              padding: "5px",
                                                              color: "green",
                                                            }}
                                                          ></i>
                                                        </a>
                                                        {idx !==
                                                          firstThreeLinks.length -
                                                            1 && (
                                                          <span>, </span>
                                                        )}
                                                      </span>
                                                    ),
                                                  )
                                                ) : (
                                                  <span
                                                    style={{ color: "gray" }}
                                                  >
                                                    Not Available
                                                  </span>
                                                );
                                              })()}
                                            </td>

                                            <td>
                                              Notes <br></br>{" "}
                                              {(() => {
                                                const notesLink = Array.isArray(
                                                  teacher.notesLink,
                                                )
                                                  ? teacher.notesLink
                                                  : JSON.parse(
                                                      teacher.notesLink || "[]",
                                                    );
                                                const firstThreeLinksnotes =
                                                  notesLink.slice(0, 6); // Limit to first 3
                                                return firstThreeLinksnotes.length >
                                                  0 ? (
                                                  firstThreeLinksnotes.map(
                                                    (onnotes, idx2) => (
                                                      <span key={idx2}>
                                                        <a
                                                          href={`${onnotes}`}
                                                          style={{
                                                            color: "black",
                                                          }}
                                                          target="_blank"
                                                          rel="noopener noreferrer"
                                                        >
                                                          <i
                                                            class="fa fa-file-pdf-o"
                                                            style={{
                                                              fontSize: "18px",
                                                              fontWeight: "800",
                                                              padding: "5px",
                                                              color: "red",
                                                            }}
                                                          ></i>
                                                        </a>
                                                        {idx2 !==
                                                          firstThreeLinksnotes.length -
                                                            1 && (
                                                          <span>, </span>
                                                        )}
                                                      </span>
                                                    ),
                                                  )
                                                ) : (
                                                  <span
                                                    style={{ color: "gray" }}
                                                  >
                                                    Not Available
                                                  </span>
                                                );
                                              })()}
                                            </td>
                                          </tr>

                                          <tr>
                                            <th scope="row">Recorded Plan</th>
                                            <td>
                                              <Link to={"../studentregister"}>
                                                <i
                                                  class="fa fa-video-camera"
                                                  style={{
                                                    fontSize: "16px",
                                                    padding: "5px",
                                                    color: "red",
                                                  }}
                                                ></i>
                                              </Link>
                                            </td>
                                            <td>
                                              <a
                                                href=""
                                                style={{ color: "black" }}
                                              >
                                                Recorded,Live Class Available
                                              </a>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>

                                      <div className="row">
                                        <div className="col-lg-6 col-6">
                                          <Link
                                            target="_blank"
                                            to={`https://cxqyp.courses.store/770868?utm_source%3Dother%26utm_medium%3Dtutor-course-referral%26utm_campaign%3Dcourse-overview-webapp`}
                                          >
                                            <button class="py-1 mt-1 blink-button">
                                              Join Live
                                              <DuoIcon />
                                            </button>
                                          </Link>
                                          {/* <Link
                                    target="_blank"
                                    to={`https://sfu.mirotalk.com/join/${teacher.TeacherName}-${teacher.TeacherId}`}
                                  >
                                    <button class="py-1 mt-1 blink-button">
                                      Join Live
                                      <DuoIcon />
                                    </button>
                                  </Link> */}
                                        </div>
                                        <div className="col-lg-6 col-6">
                                          <div className="apply-btn">
                                            <Link
                                              style={{
                                                background: "rgb(0 104 22)",
                                                borderRadius: "5px",
                                              }}
                                              to={`../our-batches`}
                                            >
                                              Parchase Batches
                                            </Link>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-5">
                                      <div
                                        key={teacher.TeacherIds}
                                        style={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                        }}
                                      >
                                        <a
                                          onClick={() =>
                                            handleShare(
                                              teacher.TeacherId,
                                              teacher.TeacherName,
                                            )
                                          }
                                          title="Share Profile"
                                          style={{
                                            color: "#2341f6",
                                            cursor: "pointer",
                                            display: "flex",
                                            alignItems: "center",
                                          }}
                                        >
                                          Share Profile
                                          <img
                                            src="https://cdn-icons-png.flaticon.com/256/7579/7579713.png"
                                            alt="Share"
                                            style={{
                                              width: "62px",
                                              height: "52px",
                                              marginLeft: "5px",
                                            }}
                                          />
                                        </a>
                                      </div>

                                      <ul>
                                        <li>
                                          <span>Experience :</span>{" "}
                                          {teacher.TeacherExperience}
                                        </li>
                                        <li>
                                          <span>Medium :</span>
                                          {teacher.TeacherMedium}
                                        </li>
                                        <li>
                                          <span>Examination :</span>{" "}
                                          {teacher.TeacherExamination}
                                        </li>
                                        <li>
                                          <span>Course :</span>{" "}
                                          {teacher.TeacherCourse}
                                        </li>
                                        <li>
                                          <span>Subject :</span>{" "}
                                          {teacher.TeacherSubject}
                                        </li>
                                        <li>
                                          <span>Address :</span>{" "}
                                          {teacher.TeacherAddress}
                                        </li>
                                      </ul>
                                      <ul>
                                        <li>
                                          <span>Fee :</span> -
                                        </li>
                                        <li>
                                          <div className="social-icon ">
                                            <a
                                              className="adds"
                                              href="tel:9911753333"
                                            >
                                              <img
                                                src="assetsfront/images/phon.png"
                                                style={{
                                                  width: "32px",
                                                  height: "34px",
                                                }}
                                              />
                                            </a>
                                            <a
                                              className="adds"
                                              href="mailto:topfauclty01@gmail.com"
                                            >
                                              <img
                                                src="assetsfront/images/email.jpg"
                                                style={{
                                                  width: "32px",
                                                  height: "34px",
                                                }}
                                              />
                                            </a>

                                            <a
                                              className="adds"
                                              href="https://www.facebook.com/topfacultyho/?show_switched_toast=0&show_invite_to_follow=0&show_switched_tooltip=0&show_podcast_settings=0&show_community_review_changes=0&show_community_rollback=0&show_follower_visibility_disclosure=0"
                                            >
                                              <img
                                                src="assetsfront/images/facebook.png"
                                                style={{
                                                  width: "32px",
                                                  height: "34px",
                                                }}
                                              />
                                            </a>
                                            <a
                                              className="adds"
                                              href="https://www.youtube.com/@vedantaiasacademy7008"
                                            >
                                              <img
                                                src="assetsfront/images/youtube.png"
                                                style={{
                                                  width: "32px",
                                                  height: "34px",
                                                }}
                                              />
                                            </a>
                                            <a
                                              className="adds"
                                              href="https://x.com/i/flow/login?redirect_after_login=%2FVEDANTA_IAS"
                                            >
                                              <img
                                                src="assetsfront/images/tweet.webp"
                                                style={{
                                                  width: "32px",
                                                  height: "34px",
                                                }}
                                              />
                                            </a>
                                            <a
                                              className="adds"
                                              href="https://www.instagram.com/vedantaias97/#"
                                            >
                                              <img
                                                src="assetsfront/images/instagram.png"
                                                style={{
                                                  width: "32px",
                                                  height: "34px",
                                                }}
                                              />
                                            </a>
                                            <a
                                              className="adds"
                                              href="https://www.linkedin.com/in/vedanta-ias-academy-75b042146/"
                                            >
                                              <img
                                                src="assetsfront/images/linkedin.png"
                                                style={{
                                                  width: "32px",
                                                  height: "34px",
                                                }}
                                              />
                                            </a>
                                          </div>
                                        </li>
                                      </ul>
                                      <div className="apply-btn">
                                        <Link
                                          style={{
                                            background: "#031671",
                                            borderRadius: "5px",
                                          }}
                                          to={`/teacher/${teacher.TeacherId}/${teacher.TeacherName}`}
                                        >
                                          View More{" "}
                                          <DoubleArrowIcon className="right-move1" />
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                    ) : (
                      <div className="course-content p-1">
                        <div className="course-instructor">
                          <div className="row">
                            <span
                              style={{
                                fontWeight: "bold",
                                color: "#002347",
                                fontSize: "30px",
                              }}
                            >
                              Loading
                              <span className="dot-loader">
                                <span className="dot"></span>
                                <span className="dot"></span>
                                <span className="dot"></span>
                                <span className="dot"></span>
                                <span className="dot"></span>
                                <span className="dot"></span>
                                <span className="dot"></span>
                                <span className="dot"></span>
                                <span className="dot"></span>
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {activeTab === "two" && (
                  <div>
                    <RelatedTeacher />
                  </div>
                )}

                {activeTab === "three" && (
                  <div>
                    <h3
                      style={{ fontWeight: "600", fontSize: "26px" }}
                      class="instructor-title"
                    >
                      UPSC{" "}
                      <span class="info-color">
                        <b>Faculty </b>
                      </span>
                    </h3>
                    {teachers && teachers.length > 0 ? (
                      teachers
                        .filter((teacher) => {
                          if (!teacher.TeacherExamination) return false;

                          return (
                            teacher.TeacherExamination.toLowerCase() === "upsc"
                          );
                        })
                        .map((teacher, index) => (
                          <div className="course-content p-1">
                            <div className="course-instructor">
                              <div className="row">
                                <div className="col-md-3 mobile-mb-20">
                                  <h3 className="instructor-title">
                                    COURSE{" "}
                                    <span className="primary-color">
                                      INSTRUCTOR{" "}
                                    </span>
                                  </h3>
                                  <div className="instructor-inner">
                                    {/* Ribbon */}

                                    {teacher.TeacherStatus === "verify" ? (
                                      <div className="ribbon ribbon-top-left">
                                        <span>VERIFY</span>
                                      </div>
                                    ) : teacher.TeacherStatus ===
                                      "un_verify" ? (
                                      <div className="ribbon2">
                                        <span>Under-Verification</span>
                                      </div>
                                    ) : null}

                                    <div className="instructor-img">
                                      <img
                                        style={{ maxWidth: "65%" }}
                                        src={
                                          teacher.TeacherProfile
                                            ? teacher.TeacherProfile
                                            : "https://i.pinimg.com/736x/5f/40/6a/5f406ab25e8942cbe0da6485afd26b71.jpg"
                                        }
                                        alt={teacher.TeacherName}
                                      />
                                    </div>
                                  </div>

                                  <div className="instructor-body">
                                    <h4
                                      className="name"
                                      style={{
                                        marginBottom: "2px",
                                        color: "#007bff",
                                        fontWeight: "800",
                                      }}
                                    >
                                      {teacher.TeacherName}{" "}
                                    </h4>

                                    <span
                                      className="designation"
                                      style={{
                                        color: "black",
                                        fontWeight: "600",
                                      }}
                                      title={teacher.TeacherEmail}
                                    >
                                      {teacher.TeacherEmail.length > 17
                                        ? teacher.TeacherEmail.substring(
                                            0,
                                            17,
                                          ) + "..."
                                        : teacher.TeacherEmail}
                                    </span>
                                    <div
                                      className="social-icon mt-2"
                                      style={{ letterSpacing: "9px" }}
                                    >
                                      {/* <a href={`tel:${teacher.TeacherMobile}`}><img src="assetsfront/images/phon.png" style={{width: "32px",height: "34px"}}/></a> */}
                                      {/* <a className="adds" href={`mailto:${teacher.TeacherEmail}`}><img src="assetsfront/images/email.jpg" style={{width: "32px",height: "34px"}}/></a> */}
                                      <a
                                        className="adds"
                                        href={teacher.facebook}
                                      >
                                        <img
                                          src="assetsfront/images/facebook.png"
                                          style={{
                                            width: "32px",
                                            height: "34px",
                                          }}
                                        />
                                      </a>
                                      <a
                                        className="adds"
                                        href={teacher.youtube}
                                      >
                                        <img
                                          src="assetsfront/images/youtube.png"
                                          style={{
                                            width: "32px",
                                            height: "34px",
                                          }}
                                        />
                                      </a>
                                      <a
                                        className="adds"
                                        href={teacher.twitter}
                                      >
                                        <img
                                          src="assetsfront/images/tweet.webp"
                                          style={{
                                            width: "32px",
                                            height: "34px",
                                          }}
                                        />
                                      </a>
                                      <a className="adds" href={teacher.insta}>
                                        <img
                                          src="assetsfront/images/instagram.png"
                                          style={{
                                            width: "32px",
                                            height: "34px",
                                          }}
                                        />
                                      </a>
                                      <a
                                        className="adds"
                                        href={teacher.telegram}
                                      >
                                        <img
                                          src="assetsfront/images/telegram.png"
                                          style={{
                                            width: "32px",
                                            height: "34px",
                                          }}
                                        />
                                      </a>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-9">
                                  <h3 className="instructor-title">
                                    BASIC{" "}
                                    <span className="primary-color">
                                      INFORMATION
                                    </span>
                                  </h3>

                                  <div className="row info-list">
                                    <div className="col-md-7">
                                      <p style={{ fontWeight: "600" }}>
                                        Top Faculty is a powerful platform for
                                        educators to reach students across India
                                        and share their expertise.
                                      </p>

                                      <table
                                        class="table table-striped"
                                        style={{
                                          boxShadow:
                                            "rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px",
                                        }}
                                      >
                                        <tbody>
                                          <tr>
                                            <th scope="row">Online Classes</th>

                                            <td style={{ width: "100%" }}>
                                              Demo <br></br>
                                              {/* Video link block */}
                                              {(() => {
                                                const videoLinks =
                                                  Array.isArray(
                                                    teacher.videoLink,
                                                  )
                                                    ? teacher.videoLink
                                                    : JSON.parse(
                                                        teacher.videoLink ||
                                                          "[]",
                                                      );
                                                const firstThreeLinks =
                                                  videoLinks.slice(0, 6); // Limit to first 3
                                                return firstThreeLinks.length >
                                                  0 ? (
                                                  firstThreeLinks.map(
                                                    (onvideo, idx) => (
                                                      <span key={idx}>
                                                        <a
                                                          href={`${onvideo}`}
                                                          style={{
                                                            color: "black",
                                                          }}
                                                          target="_blank"
                                                          rel="noopener noreferrer"
                                                        >
                                                          <i
                                                            className="fa fa-video-camera"
                                                            style={{
                                                              fontSize: "16px",
                                                              padding: "5px",
                                                              color: "green",
                                                            }}
                                                          ></i>
                                                        </a>
                                                        {idx !==
                                                          firstThreeLinks.length -
                                                            1 && (
                                                          <span>, </span>
                                                        )}
                                                      </span>
                                                    ),
                                                  )
                                                ) : (
                                                  <span
                                                    style={{ color: "gray" }}
                                                  >
                                                    Not Available
                                                  </span>
                                                );
                                              })()}
                                            </td>

                                            <td>
                                              Notes <br></br>{" "}
                                              {(() => {
                                                const notesLink = Array.isArray(
                                                  teacher.notesLink,
                                                )
                                                  ? teacher.notesLink
                                                  : JSON.parse(
                                                      teacher.notesLink || "[]",
                                                    );
                                                const firstThreeLinksnotes =
                                                  notesLink.slice(0, 6); // Limit to first 3
                                                return firstThreeLinksnotes.length >
                                                  0 ? (
                                                  firstThreeLinksnotes.map(
                                                    (onnotes, idx2) => (
                                                      <span key={idx2}>
                                                        <a
                                                          href={`${onnotes}`}
                                                          style={{
                                                            color: "black",
                                                          }}
                                                          target="_blank"
                                                          rel="noopener noreferrer"
                                                        >
                                                          <i
                                                            class="fa fa-file-pdf-o"
                                                            style={{
                                                              fontSize: "18px",
                                                              fontWeight: "800",
                                                              padding: "5px",
                                                              color: "red",
                                                            }}
                                                          ></i>
                                                        </a>
                                                        {idx2 !==
                                                          firstThreeLinksnotes.length -
                                                            1 && (
                                                          <span>, </span>
                                                        )}
                                                      </span>
                                                    ),
                                                  )
                                                ) : (
                                                  <span
                                                    style={{ color: "gray" }}
                                                  >
                                                    Not Available
                                                  </span>
                                                );
                                              })()}
                                            </td>
                                          </tr>

                                          <tr>
                                            <th scope="row">Recorded Plan</th>
                                            <td>
                                              <Link to={"../studentregister"}>
                                                <i
                                                  class="fa fa-video-camera"
                                                  style={{
                                                    fontSize: "16px",
                                                    padding: "5px",
                                                    color: "red",
                                                  }}
                                                ></i>
                                              </Link>
                                            </td>
                                            <td>
                                              <a
                                                href=""
                                                style={{ color: "black" }}
                                              >
                                                Recorded,Live Class Available
                                              </a>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>

                                      <div className="row">
                                        <div className="col-lg-6 col-6">
                                          <Link
                                            target="_blank"
                                            to={`https://cxqyp.courses.store/770868?utm_source%3Dother%26utm_medium%3Dtutor-course-referral%26utm_campaign%3Dcourse-overview-webapp`}
                                          >
                                            <button class="py-1 mt-1 blink-button">
                                              Join Live
                                              <DuoIcon />
                                            </button>
                                          </Link>
                                          {/* <Link
                                    target="_blank"
                                    to={`https://sfu.mirotalk.com/join/${teacher.TeacherName}-${teacher.TeacherId}`}
                                  >
                                    <button class="py-1 mt-1 blink-button">
                                      Join Live
                                      <DuoIcon />
                                    </button>
                                  </Link> */}
                                        </div>
                                        <div className="col-lg-6 col-6">
                                          <div className="apply-btn">
                                            <Link
                                              style={{
                                                background: "rgb(0 104 22)",
                                                borderRadius: "5px",
                                              }}
                                              to={`../our-batches`}
                                            >
                                              Parchase Batches
                                            </Link>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-5">
                                      <div
                                        key={teacher.TeacherIds}
                                        style={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                        }}
                                      >
                                        <a
                                          onClick={() =>
                                            handleShare(
                                              teacher.TeacherId,
                                              teacher.TeacherName,
                                            )
                                          }
                                          title="Share Profile"
                                          style={{
                                            color: "#2341f6",
                                            cursor: "pointer",
                                            display: "flex",
                                            alignItems: "center",
                                          }}
                                        >
                                          Share Profile
                                          <img
                                            src="https://cdn-icons-png.flaticon.com/256/7579/7579713.png"
                                            alt="Share"
                                            style={{
                                              width: "62px",
                                              height: "52px",
                                              marginLeft: "5px",
                                            }}
                                          />
                                        </a>
                                      </div>

                                      <ul>
                                        <li>
                                          <span>Experience :</span>{" "}
                                          {teacher.TeacherExperience}
                                        </li>
                                        <li>
                                          <span>Medium :</span>
                                          {teacher.TeacherMedium}
                                        </li>
                                        <li>
                                          <span>Examination :</span>{" "}
                                          {teacher.TeacherExamination}
                                        </li>
                                        <li>
                                          <span>Course :</span>{" "}
                                          {teacher.TeacherCourse}
                                        </li>
                                        <li>
                                          <span>Subject :</span>{" "}
                                          {teacher.TeacherSubject}
                                        </li>
                                        <li>
                                          <span>Address :</span>{" "}
                                          {teacher.TeacherAddress}
                                        </li>
                                      </ul>
                                      <ul>
                                        <li>
                                          <span>Fee :</span> -
                                        </li>
                                        <li>
                                          <div className="social-icon ">
                                            <a
                                              className="adds"
                                              href="tel:9911753333"
                                            >
                                              <img
                                                src="assetsfront/images/phon.png"
                                                style={{
                                                  width: "32px",
                                                  height: "34px",
                                                }}
                                              />
                                            </a>
                                            <a
                                              className="adds"
                                              href="mailto:topfauclty01@gmail.com"
                                            >
                                              <img
                                                src="assetsfront/images/email.jpg"
                                                style={{
                                                  width: "32px",
                                                  height: "34px",
                                                }}
                                              />
                                            </a>

                                            <a
                                              className="adds"
                                              href="https://www.facebook.com/topfacultyho/?show_switched_toast=0&show_invite_to_follow=0&show_switched_tooltip=0&show_podcast_settings=0&show_community_review_changes=0&show_community_rollback=0&show_follower_visibility_disclosure=0"
                                            >
                                              <img
                                                src="assetsfront/images/facebook.png"
                                                style={{
                                                  width: "32px",
                                                  height: "34px",
                                                }}
                                              />
                                            </a>
                                            <a
                                              className="adds"
                                              href="https://www.youtube.com/@vedantaiasacademy7008"
                                            >
                                              <img
                                                src="assetsfront/images/youtube.png"
                                                style={{
                                                  width: "32px",
                                                  height: "34px",
                                                }}
                                              />
                                            </a>
                                            <a
                                              className="adds"
                                              href="https://x.com/i/flow/login?redirect_after_login=%2FVEDANTA_IAS"
                                            >
                                              <img
                                                src="assetsfront/images/tweet.webp"
                                                style={{
                                                  width: "32px",
                                                  height: "34px",
                                                }}
                                              />
                                            </a>
                                            <a
                                              className="adds"
                                              href="https://www.instagram.com/vedantaias97/#"
                                            >
                                              <img
                                                src="assetsfront/images/instagram.png"
                                                style={{
                                                  width: "32px",
                                                  height: "34px",
                                                }}
                                              />
                                            </a>
                                            <a
                                              className="adds"
                                              href="https://www.linkedin.com/in/vedanta-ias-academy-75b042146/"
                                            >
                                              <img
                                                src="assetsfront/images/linkedin.png"
                                                style={{
                                                  width: "32px",
                                                  height: "34px",
                                                }}
                                              />
                                            </a>
                                          </div>
                                        </li>
                                      </ul>
                                      <div className="apply-btn">
                                        <Link
                                          style={{
                                            background: "#031671",
                                            borderRadius: "5px",
                                          }}
                                          to={`/teacher/${teacher.TeacherId}/${teacher.TeacherName}`}
                                        >
                                          View More{" "}
                                          <DoubleArrowIcon className="right-move1" />
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                    ) : (
                      <div className="course-content p-1">
                        <div className="course-instructor">
                          <div className="row">
                            <span
                              style={{
                                fontWeight: "bold",
                                color: "#002347",
                                fontSize: "30px",
                              }}
                            >
                              Loading
                              <span className="dot-loader">
                                <span className="dot"></span>
                                <span className="dot"></span>
                                <span className="dot"></span>
                                <span className="dot"></span>
                                <span className="dot"></span>
                                <span className="dot"></span>
                                <span className="dot"></span>
                                <span className="dot"></span>
                                <span className="dot"></span>
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
                {activeTab === "four" && (
                  <div>
                    <h3
                      style={{ fontWeight: "600", fontSize: "26px" }}
                      class="instructor-title"
                    >
                      Teaching{" "}
                      <span class="info-color">
                        <b>Faculty </b>
                      </span>
                    </h3>
                    {teachers && teachers.length > 0 ? (
                      teachers
                        .filter((teacher) => {
                          if (!teacher.TeacherExamination) return false;

                          return (
                            teacher.TeacherExamination.toLowerCase() ===
                            "teaching"
                          );
                        })
                        .map((teacher, index) => (
                          <div className="course-content p-1">
                            <div className="course-instructor">
                              <div className="row">
                                <div className="col-md-3 mobile-mb-20">
                                  <h3 className="instructor-title">
                                    COURSE{" "}
                                    <span className="primary-color">
                                      INSTRUCTOR{" "}
                                    </span>
                                  </h3>
                                  <div className="instructor-inner">
                                    {/* Ribbon */}

                                    {teacher.TeacherStatus === "verify" ? (
                                      <div className="ribbon ribbon-top-left">
                                        <span>VERIFY</span>
                                      </div>
                                    ) : teacher.TeacherStatus ===
                                      "un_verify" ? (
                                      <div className="ribbon2">
                                        <span>Under-Verification</span>
                                      </div>
                                    ) : null}

                                    <div className="instructor-img">
                                      <img
                                        style={{ maxWidth: "65%" }}
                                        src={
                                          teacher.TeacherProfile
                                            ? teacher.TeacherProfile
                                            : "https://i.pinimg.com/736x/5f/40/6a/5f406ab25e8942cbe0da6485afd26b71.jpg"
                                        }
                                        alt={teacher.TeacherName}
                                      />
                                    </div>
                                  </div>

                                  <div className="instructor-body">
                                    <h4
                                      className="name"
                                      style={{
                                        marginBottom: "2px",
                                        color: "#007bff",
                                        fontWeight: "800",
                                      }}
                                    >
                                      {teacher.TeacherName}{" "}
                                    </h4>

                                    <span
                                      className="designation"
                                      style={{
                                        color: "black",
                                        fontWeight: "600",
                                      }}
                                      title={teacher.TeacherEmail}
                                    >
                                      {teacher.TeacherEmail.length > 17
                                        ? teacher.TeacherEmail.substring(
                                            0,
                                            17,
                                          ) + "..."
                                        : teacher.TeacherEmail}
                                    </span>
                                    <div
                                      className="social-icon mt-2"
                                      style={{ letterSpacing: "9px" }}
                                    >
                                      {/* <a href={`tel:${teacher.TeacherMobile}`}><img src="assetsfront/images/phon.png" style={{width: "32px",height: "34px"}}/></a> */}
                                      {/* <a className="adds" href={`mailto:${teacher.TeacherEmail}`}><img src="assetsfront/images/email.jpg" style={{width: "32px",height: "34px"}}/></a> */}
                                      <a
                                        className="adds"
                                        href={teacher.facebook}
                                      >
                                        <img
                                          src="assetsfront/images/facebook.png"
                                          style={{
                                            width: "32px",
                                            height: "34px",
                                          }}
                                        />
                                      </a>
                                      <a
                                        className="adds"
                                        href={teacher.youtube}
                                      >
                                        <img
                                          src="assetsfront/images/youtube.png"
                                          style={{
                                            width: "32px",
                                            height: "34px",
                                          }}
                                        />
                                      </a>
                                      <a
                                        className="adds"
                                        href={teacher.twitter}
                                      >
                                        <img
                                          src="assetsfront/images/tweet.webp"
                                          style={{
                                            width: "32px",
                                            height: "34px",
                                          }}
                                        />
                                      </a>
                                      <a className="adds" href={teacher.insta}>
                                        <img
                                          src="assetsfront/images/instagram.png"
                                          style={{
                                            width: "32px",
                                            height: "34px",
                                          }}
                                        />
                                      </a>
                                      <a
                                        className="adds"
                                        href={teacher.telegram}
                                      >
                                        <img
                                          src="assetsfront/images/telegram.png"
                                          style={{
                                            width: "32px",
                                            height: "34px",
                                          }}
                                        />
                                      </a>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-9">
                                  <h3 className="instructor-title">
                                    BASIC{" "}
                                    <span className="primary-color">
                                      INFORMATION
                                    </span>
                                  </h3>

                                  <div className="row info-list">
                                    <div className="col-md-7">
                                      <p style={{ fontWeight: "600" }}>
                                        Top Faculty is a powerful platform for
                                        educators to reach students across India
                                        and share their expertise.
                                      </p>

                                      <table
                                        class="table table-striped"
                                        style={{
                                          boxShadow:
                                            "rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px",
                                        }}
                                      >
                                        <tbody>
                                          <tr>
                                            <th scope="row">Online Classes</th>

                                            <td style={{ width: "100%" }}>
                                              Demo <br></br>
                                              {/* Video link block */}
                                              {(() => {
                                                const videoLinks =
                                                  Array.isArray(
                                                    teacher.videoLink,
                                                  )
                                                    ? teacher.videoLink
                                                    : JSON.parse(
                                                        teacher.videoLink ||
                                                          "[]",
                                                      );
                                                const firstThreeLinks =
                                                  videoLinks.slice(0, 6); // Limit to first 3
                                                return firstThreeLinks.length >
                                                  0 ? (
                                                  firstThreeLinks.map(
                                                    (onvideo, idx) => (
                                                      <span key={idx}>
                                                        <a
                                                          href={`${onvideo}`}
                                                          style={{
                                                            color: "black",
                                                          }}
                                                          target="_blank"
                                                          rel="noopener noreferrer"
                                                        >
                                                          <i
                                                            className="fa fa-video-camera"
                                                            style={{
                                                              fontSize: "16px",
                                                              padding: "5px",
                                                              color: "green",
                                                            }}
                                                          ></i>
                                                        </a>
                                                        {idx !==
                                                          firstThreeLinks.length -
                                                            1 && (
                                                          <span>, </span>
                                                        )}
                                                      </span>
                                                    ),
                                                  )
                                                ) : (
                                                  <span
                                                    style={{ color: "gray" }}
                                                  >
                                                    Not Available
                                                  </span>
                                                );
                                              })()}
                                            </td>

                                            <td>
                                              Notes <br></br>{" "}
                                              {(() => {
                                                const notesLink = Array.isArray(
                                                  teacher.notesLink,
                                                )
                                                  ? teacher.notesLink
                                                  : JSON.parse(
                                                      teacher.notesLink || "[]",
                                                    );
                                                const firstThreeLinksnotes =
                                                  notesLink.slice(0, 6); // Limit to first 3
                                                return firstThreeLinksnotes.length >
                                                  0 ? (
                                                  firstThreeLinksnotes.map(
                                                    (onnotes, idx2) => (
                                                      <span key={idx2}>
                                                        <a
                                                          href={`${onnotes}`}
                                                          style={{
                                                            color: "black",
                                                          }}
                                                          target="_blank"
                                                          rel="noopener noreferrer"
                                                        >
                                                          <i
                                                            class="fa fa-file-pdf-o"
                                                            style={{
                                                              fontSize: "18px",
                                                              fontWeight: "800",
                                                              padding: "5px",
                                                              color: "red",
                                                            }}
                                                          ></i>
                                                        </a>
                                                        {idx2 !==
                                                          firstThreeLinksnotes.length -
                                                            1 && (
                                                          <span>, </span>
                                                        )}
                                                      </span>
                                                    ),
                                                  )
                                                ) : (
                                                  <span
                                                    style={{ color: "gray" }}
                                                  >
                                                    Not Available
                                                  </span>
                                                );
                                              })()}
                                            </td>
                                          </tr>

                                          <tr>
                                            <th scope="row">Recorded Plan</th>
                                            <td>
                                              <Link to={"../studentregister"}>
                                                <i
                                                  class="fa fa-video-camera"
                                                  style={{
                                                    fontSize: "16px",
                                                    padding: "5px",
                                                    color: "red",
                                                  }}
                                                ></i>
                                              </Link>
                                            </td>
                                            <td>
                                              <a
                                                href=""
                                                style={{ color: "black" }}
                                              >
                                                Recorded,Live Class Available
                                              </a>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>

                                      <div className="row">
                                        <div className="col-lg-6 col-6">
                                          <Link
                                            target="_blank"
                                            to={`https://cxqyp.courses.store/770868?utm_source%3Dother%26utm_medium%3Dtutor-course-referral%26utm_campaign%3Dcourse-overview-webapp`}
                                          >
                                            <button class="py-1 mt-1 blink-button">
                                              Join Live
                                              <DuoIcon />
                                            </button>
                                          </Link>
                                          {/* <Link
                                    target="_blank"
                                    to={`https://sfu.mirotalk.com/join/${teacher.TeacherName}-${teacher.TeacherId}`}
                                  >
                                    <button class="py-1 mt-1 blink-button">
                                      Join Live
                                      <DuoIcon />
                                    </button>
                                  </Link> */}
                                        </div>
                                        <div className="col-lg-6 col-6">
                                          <div className="apply-btn">
                                            <Link
                                              style={{
                                                background: "rgb(0 104 22)",
                                                borderRadius: "5px",
                                              }}
                                              to={`../our-batches`}
                                            >
                                              Parchase Batches
                                            </Link>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-5">
                                      <div
                                        key={teacher.TeacherIds}
                                        style={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                        }}
                                      >
                                        <a
                                          onClick={() =>
                                            handleShare(
                                              teacher.TeacherId,
                                              teacher.TeacherName,
                                            )
                                          }
                                          title="Share Profile"
                                          style={{
                                            color: "#2341f6",
                                            cursor: "pointer",
                                            display: "flex",
                                            alignItems: "center",
                                          }}
                                        >
                                          Share Profile
                                          <img
                                            src="https://cdn-icons-png.flaticon.com/256/7579/7579713.png"
                                            alt="Share"
                                            style={{
                                              width: "62px",
                                              height: "52px",
                                              marginLeft: "5px",
                                            }}
                                          />
                                        </a>
                                      </div>

                                      <ul>
                                        <li>
                                          <span>Experience :</span>{" "}
                                          {teacher.TeacherExperience}
                                        </li>
                                        <li>
                                          <span>Medium :</span>
                                          {teacher.TeacherMedium}
                                        </li>
                                        <li>
                                          <span>Examination :</span>{" "}
                                          {teacher.TeacherExamination}
                                        </li>
                                        <li>
                                          <span>Course :</span>{" "}
                                          {teacher.TeacherCourse}
                                        </li>
                                        <li>
                                          <span>Subject :</span>{" "}
                                          {teacher.TeacherSubject}
                                        </li>
                                        <li>
                                          <span>Address :</span>{" "}
                                          {teacher.TeacherAddress}
                                        </li>
                                      </ul>
                                      <ul>
                                        <li>
                                          <span>Fee :</span> -
                                        </li>
                                        <li>
                                          <div className="social-icon ">
                                            <a
                                              className="adds"
                                              href="tel:9911753333"
                                            >
                                              <img
                                                src="assetsfront/images/phon.png"
                                                style={{
                                                  width: "32px",
                                                  height: "34px",
                                                }}
                                              />
                                            </a>
                                            <a
                                              className="adds"
                                              href="mailto:topfauclty01@gmail.com"
                                            >
                                              <img
                                                src="assetsfront/images/email.jpg"
                                                style={{
                                                  width: "32px",
                                                  height: "34px",
                                                }}
                                              />
                                            </a>

                                            <a
                                              className="adds"
                                              href="https://www.facebook.com/topfacultyho/?show_switched_toast=0&show_invite_to_follow=0&show_switched_tooltip=0&show_podcast_settings=0&show_community_review_changes=0&show_community_rollback=0&show_follower_visibility_disclosure=0"
                                            >
                                              <img
                                                src="assetsfront/images/facebook.png"
                                                style={{
                                                  width: "32px",
                                                  height: "34px",
                                                }}
                                              />
                                            </a>
                                            <a
                                              className="adds"
                                              href="https://www.youtube.com/@vedantaiasacademy7008"
                                            >
                                              <img
                                                src="assetsfront/images/youtube.png"
                                                style={{
                                                  width: "32px",
                                                  height: "34px",
                                                }}
                                              />
                                            </a>
                                            <a
                                              className="adds"
                                              href="https://x.com/i/flow/login?redirect_after_login=%2FVEDANTA_IAS"
                                            >
                                              <img
                                                src="assetsfront/images/tweet.webp"
                                                style={{
                                                  width: "32px",
                                                  height: "34px",
                                                }}
                                              />
                                            </a>
                                            <a
                                              className="adds"
                                              href="https://www.instagram.com/vedantaias97/#"
                                            >
                                              <img
                                                src="assetsfront/images/instagram.png"
                                                style={{
                                                  width: "32px",
                                                  height: "34px",
                                                }}
                                              />
                                            </a>
                                            <a
                                              className="adds"
                                              href="https://www.linkedin.com/in/vedanta-ias-academy-75b042146/"
                                            >
                                              <img
                                                src="assetsfront/images/linkedin.png"
                                                style={{
                                                  width: "32px",
                                                  height: "34px",
                                                }}
                                              />
                                            </a>
                                          </div>
                                        </li>
                                      </ul>
                                      <div className="apply-btn">
                                        <Link
                                          style={{
                                            background: "#031671",
                                            borderRadius: "5px",
                                          }}
                                          to={`/teacher/${teacher.TeacherId}/${teacher.TeacherName}`}
                                        >
                                          View More{" "}
                                          <DoubleArrowIcon className="right-move1" />
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                    ) : (
                      <div className="course-content p-1">
                        <div className="course-instructor">
                          <div className="row">
                            <span
                              style={{
                                fontWeight: "bold",
                                color: "#002347",
                                fontSize: "30px",
                              }}
                            >
                              Loading
                              <span className="dot-loader">
                                <span className="dot"></span>
                                <span className="dot"></span>
                                <span className="dot"></span>
                                <span className="dot"></span>
                                <span className="dot"></span>
                                <span className="dot"></span>
                                <span className="dot"></span>
                                <span className="dot"></span>
                                <span className="dot"></span>
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>

              <div>{examId !== undefined && <RelatedTeacher />}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Teacherlist;
